import React from "react"
import { Link } from "react-router-dom"
import Social from "../Social/Social"
import Phone from "../Shared/Phone"
import Email from "../Shared/Email"
import Directions from "../Shared/Directions"
import Reservations from "../Shared/Reservations"
import Drawer from "./Drawer"
import Newsletter from "../Shared/Newsletter"
// import Bingo from '../../Bingo.pdf'
const classes = require('./Header.module.scss')
const logo = require('../../assets/images/logoMM-white.png')

const header = () => {
  return (
    <header className={classes.Header}>      
      <div className={classes.topBar}>
        <div className={[classes.tbWrap, classes.insideN, classes.flexGroup].join(' ')}>
          <div className={[classes.tbh, classes.iphone].join(' ')}><Phone where="header" /></div>
          <div className={[classes.tbh, classes.inews].join(' ')}><Newsletter where="header" /></div>
          <div className={[classes.tbh, classes.iemail].join(' ')}>
            <span className={classes.emailGroup}><Email /></span>
            <Social where="header" />
          </div>
        </div>
      </div>

      <div className={[classes.navRow].join(' ')}>
        <nav className={[classes.navWrap, classes.inside12, classes.flexGroup, "uk-navbar-container"].join(' ')} data-uk-navbar>
          <Link to="/" className={[classes.logoBlk, "uk-logo"].join(' ')}>
            <img src={logo} alt="Mile Marker 158 Dockside Logo" className={[classes.imgResponsive, classes.ilLogo].join(' ')} />
          </Link>
          
          <ul className={[classes.navLoop, classes.flexGroup, "uk-navbar-nav"].join(' ')}>
            <li className={[classes.navItem, classes.ng1b].join(' ')}><Link to="#">Menus</Link>
              <div className={[classes.custDrop, "uk-navbar-dropdown"].join(' ')}>
                <ul className="uk-nav uk-navbar-dropdown-nav">
                  <li className={classes.dropLi}><Link to="/happy-hour">Specials</Link></li>
                  <li className={classes.dropLi}><Link to="/daily-menu">Daily Menu</Link></li>
                  <li className={classes.dropLi}><Link to="/brunch-menu">Brunch Menu</Link></li>
                  <li className={classes.dropLi}><Link to="/kids-menu">Kids Menu</Link></li>
                  <li className={classes.dropLi}><Link to="/family-meals-togo">Family Meals</Link></li>
                  <li className={classes.dropLi}><Link to="/lasagna-night">Lasagna Night</Link></li>
                  <li className={[classes.dropLi, classes.emph].join(' ')}><Link to="/wine-dinner">Wine Dinner</Link></li>
                </ul>
              </div>
            </li>
                        
            <li className={[classes.navItem, classes.ng2].join(' ')}><Link to="#">Events</Link>
              <div className={[classes.custDrop, classes.eventDrop, "uk-navbar-dropdown"].join(' ')}>
                <ul className="uk-nav uk-navbar-dropdown-nav">
                  <li className={[classes.dropLi, classes.emph].join(' ')}><Link to="/wine-dinner">Wine Dinner</Link></li>
                  <li className={classes.dropLi}><Link to="/lasagna-night">Lasagna Night</Link></li>
                </ul>
              </div>
            </li>

            <li className={[classes.navItem, classes.ng2].join(' ')}><Link to="#">Contact</Link>
              <div className={[classes.custDrop, "uk-navbar-dropdown"].join(' ')}>
                <ul className="uk-nav uk-navbar-dropdown-nav">
                  <li className={classes.dropLi}><Link to="/contact">Contact Us</Link></li>
                  <li className={classes.dropLi}><Directions /></li>
                </ul>
              </div>
            </li>

            <li className={[classes.navItem, classes.ng2].join(' ')}><a href="https://wharfcateringgroup.com/" target="_blank" rel="noopener noreferrer">Catering</a></li>

            <li className={[classes.navItem, classes.ng1].join(' ')}><Reservations /></li>

            <li className={[classes.navItem, classes.ng1].join(' ')}><Link to="#">Delivery & Takeout</Link>
              <div className={[classes.custDrop, classes.long, "uk-navbar-dropdown"].join(' ')}>
                <ul className="uk-nav uk-navbar-dropdown-nav">
                  <li className={classes.dropLi}><a href="https://order.toasttab.com/online/mile-marker-158" target="_blank" rel="noopener noreferrer" className={[classes.togo, classes.takeout].join(' ')}>Order Takeout</a></li>
                  <li className={classes.dropLi}><a href="https://www.doordash.com/store/mile-marker-158-dockside-orange-beach-27866264/114629747" target="_blank" rel="noopener noreferrer" className={[classes.togo, classes.deliv].join(' ')}>Door Dash Delivery</a></li>
                </ul>
              </div>
            </li>
          </ul>
        
          <div className={classes.mobNav}><Drawer /></div>
        </nav>        
      </div>
    </header>
  )
}

export default header


